var jsPDF = require("jspdf");
jsPDF = jsPDF.API ? jsPDF : jsPDF.default;
function hasOwnProperty(obj, propName) {
    return Object.prototype.hasOwnProperty.call(obj, propName);
}
jsPDF = "default" in jsPDF ? jsPDF["default"] : jsPDF;
function getValueOutput(v) {
    if (Array.isArray(v)) {
        return "[" + v.map(getValueOutput).join(" ") + "]";
    }
    if (typeof v === "object" && v) {
        return getDictOutput(v);
    }
    if (typeof v === "string") {
        return v;
    }
    if (typeof v === "boolean") {
        return v ? "true" : "false";
    }
    if (typeof v === "number") {
        v = v.toString();
        if (!/^[+-]?(\d*\.)?\d+$/.test(v))
            throw new Error("TaggingPlugin: Invalid PDF Number - " + v);
        return v;
    }
    throw new Error("TaggingPlugin: Invalid PDF value - " + v.toString());
}
function getDictOutput(obj) {
    var out = [], v;
    for (var key in obj) {
        if (hasOwnProperty(obj, key) && key.indexOf("_") !== 0) {
            v = obj[key];
            out.push("/" + key + " " + getValueOutput(v));
        }
    }
    return "<< " + out.join(" ") + " >>";
}
var jsPDFAPI = jsPDF.API;
var getTagging = function () {
    var tagging = this.internal.collections.tagging;
    if (!tagging) {
        this.internal.collections.tagging = tagging = {
            root: {
                Type: "/StructElem",
                S: "/Document",
                K: [],
            },
            parentTree: [],
            inMarkedContent: false,
            pageAnnotations: [],
        };
        tagging.current = tagging.root;
    }
    return tagging;
};
function fixPageReferences(node) {
    if (node._pageContext) {
        node.Pg = node._pageContext.objId + " 0 R";
    }
    if (Array.isArray(node.K)) {
        node.K.forEach(fixPageReferences);
    }
}
var putStructTreeRoot = function () {
    var obj = this.internal.newAdditionalObject();
    var tagging = getTagging.call(this);
    fixPageReferences(tagging.root);
    var K = generateStructTreeNode.call(this, tagging.root, obj.objId);
    var ret = {
        Type: "/StructTreeRoot",
        K: K + " 0 R",
        ParentTree: {
            Nums: tagging.parentTree
                .map(function (e) {
                if (Array.isArray(e)) {
                    return e.map(function (e) {
                        return e._objNum + " 0 R";
                    });
                }
                else {
                    return e._objNum + " 0 R";
                }
            })
                .reduce(function (ret, e, i) {
                return ret.concat([i, e]);
            }, []),
        },
        ParentTreeNextKey: tagging.parentTree.length,
    };
    obj.content = getDictOutput(ret);
    return obj.objId;
};
var generateStructTreeNode = function (node, parentNumber) {
    var that = this;
    var savedNode = node;
    var obj = this.internal.newAdditionalObject();
    node._objNum = obj.objId;
    node = {};
    for (var i in savedNode)
        if (hasOwnProperty(savedNode, i))
            node[i] = savedNode[i];
    node.Type = "/StructElem";
    node.P = parentNumber + " 0 R";
    node.K = node.K.map(function (c) {
        if (typeof c === "number" || c._objr)
            return c;
        return generateStructTreeNode.call(that, c, obj.objId) + " 0 R";
    });
    obj.content = getDictOutput(node);
    return obj.objId;
};
jsPDFAPI.structElem = function (options, fn) {
    // Required:
    // - options.type - (S) subtype
    //
    // Optional:
    // - options.attr - (A) attributes
    // - options.title - (T) title
    // - options.lang - (Lang) language
    // - options.alt - (Alt) Alt text (image)
    // - options.expanded - (E) Expanded Abbreviation
    // - options.actualText - (ActualText) replacement text
    // Automatically generate
    // P - Parent
    // Pg - Page
    // K - children
    if (typeof options === "string")
        options = { type: options };
    if (typeof options !== "object" || !options)
        throw new TypeError("TaggingPlugin: options must be an object");
    if (typeof options.type !== "string")
        throw new TypeError("TaggingPlugin: options.S must be a string");
    var tagging = getTagging.call(this);
    var currentNode = tagging.current;
    var pageInfo = this.internal.getCurrentPageInfo();
    var newNode = { S: "/" + options.type };
    // TODO: attributes
    if (typeof options.title === "string")
        newNode.T = "(" + this.internal.pdfEscape(options.title) + ")";
    if (typeof options.lang === "string")
        newNode.Lang = "(" + this.internal.pdfEscape(options.lang) + ")";
    if (typeof options.alt === "string")
        newNode.Alt = "(" + this.internal.pdfEscape(options.alt) + ")";
    if (typeof options.expanded === "string")
        newNode.E = "(" + this.internal.pdfEscape(options.expanded) + ")";
    if (typeof options.actualText === "string")
        newNode.ActualText = "(" + this.internal.pdfEscape(options.actualText) + ")";
    if (typeof options.attr === "object")
        newNode.A = options.attr;
    newNode.K = [];
    newNode._pageContext = pageInfo.pageContext;
    // newNode.Pg = pageInfo.objId + " 0 R";
    currentNode.K.push(newNode);
    tagging.current = newNode;
    if (typeof fn === "function")
        fn();
    tagging.current = currentNode;
    return this;
};
jsPDFAPI.markedContent = function (type, fn, options) {
    if (typeof type === "function") {
        options = fn;
        fn = type;
        type = "Span";
    }
    var tagging = getTagging.call(this);
    if (tagging.inMarkedContent) {
        throw new Error("TaggingPlugin: Cannot call markedContent inside of markedContent.");
    }
    tagging.inMarkedContent = true;
    var pageInfo = this.internal.getCurrentPageInfo();
    var newId = pageInfo.pageContext.mcidParentTree.length;
    var otherValues = [];
    if (options && options.lang) {
        otherValues.push("/Lang (" + this.internal.pdfEscape(options.lang) + ")");
    }
    this.internal.out("/" + type + " << /MCID " + newId + (otherValues.length ? otherValues.join(" ") : "") + " >> BDC");
    if (typeof fn === "function")
        fn();
    this.internal.out("EMC");
    tagging.inMarkedContent = false;
    var currentNode = tagging.current;
    pageInfo.pageContext.mcidParentTree.push(currentNode);
    currentNode.K.push(newId);
    return this;
};
function f2(number) {
    return number.toFixed(2);
}
jsPDFAPI.convertBBox = function (x, y, w, h) {
    var pageHeight = this.internal.pageSize.height;
    if (typeof pageHeight === "function")
        pageHeight = this.internal.pageSize.height();
    var k = this.internal.scaleFactor;
    return [f2(x * k), f2(pageHeight - (y + h) * k), f2((x + w) * k), f2((pageHeight - y) * k)];
};
jsPDFAPI.artifact = function (fn) {
    this.internal.out("/Artifact BMC");
    if (typeof fn === "function")
        fn();
    this.internal.out("EMC");
    return this;
};
jsPDFAPI.artifactWithProperties = function (properties, fn) {
    this.internal.out("/Artifact << ");
    if (properties.type)
        this.internal.out("/Type/" + properties.type + " ");
    if (properties.subtype)
        this.internal.out("/Subtype/" + properties.subtype + " ");
    this.internal.out(" >> BDC");
    if (typeof fn === "function")
        fn();
    this.internal.out("EMC");
    return this;
};
jsPDFAPI.a11yLink = function (x, y, w, h, options) {
    var tagging = getTagging.call(this);
    var pageInfo = this.internal.getCurrentPageInfo();
    var annotArray = tagging.pageAnnotations[pageInfo.pageNumber];
    var ref = {
        _objr: true,
        Type: "/OBJR",
        Pg: pageInfo.objId + " 0 R",
        Obj: null,
        _pageContext: pageInfo.pageContext,
    };
    var currentNode = tagging.current;
    currentNode.K.push(ref);
    annotArray.push({
        type: "link",
        x: x,
        y: y,
        w: w,
        h: h,
        options: options,
        ref: ref,
        structParent: currentNode,
    });
};
function putA11yAnnotations(pageInfo) {
    var tagging = getTagging.call(this);
    var annotArray = tagging.pageAnnotations[pageInfo.pageNumber];
    var that = this;
    if (annotArray.length < 1)
        return;
    var objs = [];
    annotArray.forEach(function (annot) {
        var outObj = null;
        var parentTreeIdx = tagging.parentTree.length;
        if (annot.type === "link") {
            outObj = {
                Type: "/Annot",
                Subtype: "/Link",
                Rect: that.convertBBox(annot.x, annot.y, annot.w, annot.h),
                Border: [0, 0, 0],
                StructParent: parentTreeIdx,
                //Contents: "(" + that.internal.pdfEscape(annot.options.alt) + ")",
                A: {
                    S: "/URI",
                    URI: "(" + that.internal.pdfEscape(annot.options.url) + ")",
                },
            };
        }
        var obj = that.internal.newAdditionalObject();
        annot.ref.Obj = obj.objId + " 0 R";
        obj.content = getDictOutput(outObj);
        objs.push(obj.objId + " 0 R");
        tagging.parentTree.push(annot.structParent);
    });
    this.internal.out("/Annots [" + objs.join(" ") + "]");
}
jsPDF.API.events.push([
    "addPage",
    function (info) {
        var tagging = getTagging.call(this);
        var pageInfo = this.internal.getPageInfo(info.pageNumber);
        pageInfo.pageContext.mcidParentTree = [];
        pageInfo.pageContext.structParents = tagging.parentTree.length;
        tagging.pageAnnotations[info.pageNumber] = [];
        tagging.parentTree.push(pageInfo.pageContext.mcidParentTree);
        // Need to add artifact around stuff that's already there
        var pageContent = this.internal.pages[info.pageNumber];
        pageContent.unshift("/Artifact BMC");
        pageContent.push("EMC");
    },
]);
jsPDFAPI.events.push([
    "putPage",
    function (info) {
        var pageInfo = this.internal.getPageInfo(info.pageNumber);
        putA11yAnnotations.call(this, info);
        this.internal.out("/StructParents " + pageInfo.pageContext.structParents);
        this.internal.out("/Tabs /S");
    },
]);
jsPDFAPI.events.push([
    "putAdditionalObjects",
    function () {
        var tagging = getTagging.call(this);
        tagging.structTreeRootNumber = putStructTreeRoot.call(this);
        tagging.metaDataNumber = putMetaData.call(this);
    },
]);
jsPDFAPI.events.push([
    "putCatalog",
    function () {
        var tagging = getTagging.call(this);
        this.internal.out("/StructTreeRoot " + tagging.structTreeRootNumber + " 0 R");
        this.internal.out("/Lang (en-CA)");
        this.internal.out("/MarkInfo <</Marked true>>");
        this.internal.out("/ViewerPreferences <</CenterWindow false /DisplayDocTitle true /FitWindow false /HideMenubar false /HideToolbar false /HideWindowUI false>>");
        if (tagging.metaDataNumber)
            this.internal.out("/Metadata " + tagging.metaDataNumber + " 0 R");
    },
]);
var entities = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
};
function escapeXml(str) {
    return str
        .split("")
        .map(function (c) {
        if (entities[c])
            return entities[c];
        var code = c.charCodeAt(0);
        if (code > 127)
            return "&#" + code + ";";
        return c;
    })
        .join("");
}
var putMetaData = function () {
    var tagging = getTagging.call(this);
    var metaData = tagging.metaData;
    if (!metaData)
        return;
    var dateStr = new Date().toISOString();
    var streamLines = [
        '<x:xmpmeta xmlns:x="adobe:ns:meta/">',
        '   <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">',
        '      <rdf:Description rdf:about=""',
        '            xmlns:dc="http://purl.org/dc/elements/1.1/"',
        '            xmlns:xmp="http://ns.adobe.com/xap/1.0/"',
        '            xmlns:pdf="http://ns.adobe.com/pdf/1.3/"',
        '            xmlns:xmpMM="http://ns.adobe.com/xap/1.0/mm/"',
        '            xmlns:pdfuaid="http://www.aiim.org/pdfua/ns/id/">',
        "         <dc:format>application/pdf</dc:format>",
        "         <dc:title>",
        "            <rdf:Alt>",
        '               <rdf:li xml:lang="x-default">' + escapeXml(metaData.title) + "</rdf:li>",
        "            </rdf:Alt>",
        "         </dc:title>",
    ];
    if (metaData.author) {
        streamLines = streamLines.concat([
            "    <dc:creator>",
            "        <rdf:Seq>",
            "            <rdf:li>" + escapeXml(metaData.author) + "</rdf:li>",
            "        </rdf:Seq>",
            "    </dc:creator>",
        ]);
    }
    if (metaData.keywords && metaData.keywords.length > 0) {
        streamLines = streamLines.concat(["    <dc:subject>", "        <rdf:Seq>"]);
        streamLines = streamLines.concat(metaData.keywords.map(function (k) {
            return "            <rdf:li>" + escapeXml(k) + "</rdf:li>";
        }));
        streamLines = streamLines.concat(["        </rdf:Seq>", "    </dc:subject>"]);
    }
    streamLines = streamLines.concat([
        "         <xmp:CreateDate>" + dateStr + "</xmp:CreateDate>",
        "         <xmp:ModifyDate>" + dateStr + "</xmp:ModifyDate>",
        "         <xmp:MetadataDate>" + dateStr + "</xmp:MetadataDate>",
        "         <pdfuaid:part>1</pdfuaid:part>",
        "      </rdf:Description>",
        "   </rdf:RDF>",
        "</x:xmpmeta>",
    ]);
    var streamContent = streamLines.join("\n");
    var objContent = [
        "<< /Type /Metadata /Subtype /XML /Length " + streamContent.length + " >>",
        "stream",
        streamContent,
        "endstream",
    ].join("\n");
    var obj = this.internal.newAdditionalObject();
    obj.content = objContent;
    return obj.objId;
};
jsPDFAPI.a11yMetadata = function (titleOrObj) {
    var tagging = getTagging.call(this);
    var metaData = (tagging.metaData =
        typeof titleOrObj === "string"
            ? {
                title: titleOrObj,
            }
            : titleOrObj);
    if (metaData.title) {
        this.__private__.setDocumentProperty("title", metaData.title);
    }
    if (metaData.author) {
        this.__private__.setDocumentProperty("author", metaData.author);
    }
    if (metaData.subject) {
        this.__private__.setDocumentProperty("subject", metaData.subject);
    }
    if (metaData.keywords && metaData.keywords.length > 0) {
        this.__private__.setDocumentProperty("keywords", metaData.keywords.join("; "));
    }
};
/*
var jsPDFAPI$1 = jsPDF.API;

var ttfFonts = [];
var ttfFontMap = {};

// non-deep clone (we don't need deep)
function cloneObj(obj) {
    var key,
        ret = {};
    for (key in obj) {
        if (hasOwnProperty(obj, key)) {
            ret[key] = obj[key];
        }
    }
    return ret;
}

// Adds the font to the proper structure for the given jspdf instance
function addFontToInst(fd, font) {
    var fontKey, newFont;
    fontKey = "F" + (Object.keys(fd.fonts).length + 1).toString(10);
    newFont = cloneObj(font);
    newFont.id = fontKey;
    fd.fonts[fontKey] = newFont;
    var fontNameLower = newFont.fontName.toLowerCase();
    if (!fd.dictionary[newFont.fontName]) {
        fd.dictionary[newFont.fontName] = {};
    }
    if (!fd.dictionary[fontNameLower]) {
        fd.dictionary[fontNameLower] = {};
    }
    fd.dictionary[newFont.fontName][newFont.fontStyle] = fontKey;
    fd.dictionary[fontNameLower][newFont.fontStyle] = fontKey;
}

// Register a new font
function addTTFFont(postScriptName, fontName, fontStyle, ttfInfo) {
    var newFont;
    if (!hasOwnProperty(ttfFontMap, fontName)) {
        ttfFontMap[fontName] = {};
    }
    newFont = {
        PostScriptName: postScriptName,
        fontName: fontName,
        fontStyle: fontStyle,
        encoding: ttfInfo.font.encoding,
        nonstandard: true,
        metadata: ttfInfo.metadata
    };
    newFont.metadata.ttfInfo = ttfInfo;

    ttfFonts.push(newFont);
    ttfFontMap[fontName][fontStyle] = newFont;
}

// Register already added fonts (when jsPDF object created)
function addFonts(fd) {
    this.originalFonts = Object.keys(fd.fonts);

    var i;
    for (i = 0; i < ttfFonts.length; i += 1) {
        addFontToInst.call(this, fd, ttfFonts[i]);
    }

    this.internal.fonts = fd.fonts;
}

function getWidths(font) {
    var first = 32,
        last = 0,
        origWidths = font.metadata.Unicode.widths,
        widths = [],
        i;

    for (i in origWidths) {
        i = parseInt(i);
        if (i && i > last) {
            last = i;
        }
    }

    last = Math.min(255, last);

    for (i = first; i <= last; i += 1) {
        widths.push(origWidths[i] ? origWidths[i] : origWidths[0]);
    }

    return {
        first: first,
        last: last,
        widths: widths
    };
}

var putFont = function(font, docFont) {
    var streamFilters = [],
        i,
        widths = getWidths(font),
        ttfInfo = font.metadata.ttfInfo,
        streamData = ttfInfo.stream.stream;

    if (ttfInfo.stream.filter) {
        for (i = 0; i < ttfInfo.stream.filter.length; i += 1) {
            streamFilters.push("/" + ttfInfo.stream.filter[i]);
        }
    }

    var streamObj = this.internal.newAdditionalObject();
    var streamDict = ttfInfo.stream.dict;
    streamObj.content = [getDictOutput(streamDict), "stream", streamData, "endstream"].join("\n");

    var descriptorObj = this.internal.newAdditionalObject();
    var descriptor = cloneObj(ttfInfo.descriptor);
    descriptor.FontFile2 = streamObj.objId + " 0 R";
    descriptorObj.content = getDictOutput(descriptor);

    var docFontObj = this.internal.newAdditionalObject();
    docFont.objectNumber = font.objectNumber = docFontObj.objId;
    var docFontContent = {
        BaseFont: "/" + font.PostScriptName,
        Type: "/Font",
        Subtype: "/TrueType",
        FontDescriptor: descriptorObj.objId + " 0 R",
        FirstChar: widths.first,
        LastChar: widths.last,
        Widths: widths.widths
    };
    if (typeof font.encoding === "string") {
        docFontContent.Encoding = "/" + font.encoding;
    }
    docFontObj.content = getDictOutput(docFontContent);
};

function getDocFont(doc, font) {
    var fontKey,
        docFonts = doc.internal.fonts;
    for (fontKey in docFonts) {
        if (hasOwnProperty(docFonts, fontKey)) {
            if (docFonts[fontKey].fontName === font.fontName && docFonts[fontKey].fontStyle === font.fontStyle) {
                return docFonts[fontKey];
            }
        }
    }
}

function putFonts() {
    var i;
    for (i = 0; i < ttfFonts.length; i += 1) {
        putFont.call(this, ttfFonts[i], getDocFont(this, ttfFonts[i]));
    }
}

// Register event to add already added TFF fonts
jsPDFAPI$1.events.push(["addFonts", addFonts]);

// This is where we want to write to the jsPDF object
jsPDFAPI$1.events.push(["putAdditionalObjects", putFonts]);

jsPDFAPI$1.events.push([
    "postPutAdditionalObjects",
    function() {
        this._savedFonts = {};
        var fonts = this.internal.fonts;
        for (var key in fonts) {
            if (hasOwnProperty(fonts, key)) this._savedFonts[key] = fonts[key];

            if (this.originalFonts.indexOf(key) < 0) delete fonts[key];
        }
    }
]);
jsPDFAPI$1.events.push([
    "putResources",
    function() {
        var fonts = this.internal.fonts;
        var savedFonts = this._savedFonts;

        for (var key in savedFonts) {
            if (hasOwnProperty(savedFonts, key) && !fonts[key]) fonts[key] = savedFonts[key];
        }
    }
]);

// Function to add TTF fonts
jsPDF.addTTFFont = addTTFFont;
*/
//# sourceMappingURL=module.js.map